// HTTP service for task recurrence rules.
//
// Wraps the v2 endpoints added in the backend branch
// pathum/4792_ops_recurrence_engine — see
// services/api/routes/v2/task_recurrence_rules.routes.js mounted at
// /api/v2/task-recurrence-rules.
//
// The recurrence engine writes generated occurrences as normal
// work_orders rows (with task_source='recurrence'), so list/detail
// reads still go through WorkOrderService.
import { httpV2 } from "../http.js";

const base = "/task-recurrence-rules";

const TaskRecurrenceRuleService = {
  // List rules. Optional criteria: { is_active, include_deleted, task_type, mode, rental_id }.
  list: (criteria = {}) => httpV2.get(base, { params: criteria }),

  get: (id) => httpV2.get(`${base}/${id}`),

  // Create a new rule. Payload shape mirrors the backend service validator —
  // see services/api/services/task_recurrence_rules.service.js.
  create: (payload) => httpV2.post(base, payload),

  // Partial update. Backend re-validates the merged payload. The
  // edit_mode field controls how in-flight occurrences are reconciled
  // (only 'future_only' is currently supported by the backend).
  update: (id, payload) =>
    httpV2.put(`${base}/${id}`, { edit_mode: "future_only", ...payload }),

  remove: (id) => httpV2.delete(`${base}/${id}`),

  deactivate: (id) => httpV2.post(`${base}/${id}/deactivate`),
  reactivate: (id) => httpV2.post(`${base}/${id}/reactivate`),

  // Dry-run preview — does NOT write any work_orders. Useful for the
  // "show me the next N occurrences" confirm step before saving.
  preview: (id, body = {}) => httpV2.post(`${base}/${id}/preview`, body),

  // Manual generation. Pass { dry_run: true } for a no-write run.
  // Without dry_run this materializes occurrences inside the rule's
  // lookahead window and the engine deduplicates against existing rows
  // via the (rule_id, occurrence_key) unique index.
  generate: (id, body = {}) => httpV2.post(`${base}/${id}/generate`, body),

  listRuns: (id) =>
    id ? httpV2.get(`${base}/${id}/runs`) : httpV2.get(`${base}/runs`),
};

export default TaskRecurrenceRuleService;
